<template>
  <v-container v-if="currentPost" class="blog-detail">
    <div class="blog-nav">
      <v-btn
        to="/blog"
        variant="text"
        prepend-icon="mdi-arrow-left"
        class="back-btn"
      >
        Back to Blog
      </v-btn>
    </div>

    <article>
      <header class="blog-header">
        <h1 class="blog-title">{{ currentPost.title }}</h1>
        <div class="blog-meta">
          <span class="publish-date">
            <v-icon size="small" class="mr-2">mdi-calendar</v-icon>
            {{ currentPost.date }}
          </span>
          <span class="read-time">
            <v-icon size="small" class="mr-2">mdi-clock-outline</v-icon>
            {{ currentPost.readTime }}
          </span>
        </div>
      </header>
      <div
        v-html="currentPost.content"
        class="blog-content"
        @click="handleBlogContentClick"
      ></div>
      <div class="author-bio">
        <img
          src="@/assets/aisha.png"
          alt="Aisha's Tech Room"
          class="author-avatar"
        />
        <div class="author-info">
          <h4>Written by Aisha</h4>
          <p>
            Frontend Developer and Developer Experience professional working in
            corporate Sweden. I share authentic, real-world advice about
            succeeding in tech based on my journey from frontend engineering to
            developer experience.
          </p>
          <div class="author-social">
            <v-btn
              icon
              size="small"
              color="#0077B5"
              href="https://www.linkedin.com/in/aisha-keita/"
              target="_blank"
            >
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
            <v-btn
              icon
              size="small"
              color="#333"
              href="https://github.com/AishaKEITA"
              target="_blank"
            >
              <v-icon>mdi-github</v-icon>
            </v-btn>
            <v-btn
              @click="sendEmail"
              class="mx-2"
              icon
              variant="text"
              aria-label="Send Email to Aisha"
            >
              <!-- Corrected label from previous example -->
              <v-icon style="color: #ff921c">mdi-email</v-icon>
            </v-btn>
            <v-btn
              icon
              size="small"
              color="#1DA1F2"
              href="https://pod.link/aHR0cHM6Ly9hbmNob3IuZm0vcy8xMGJiYTY2NzgvcG9kY2FzdC9yc3M"
              target="_blank"
            >
              <v-icon>mdi-podcast</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <footer class="blog-footer">
        <v-divider class="footer-divider"></v-divider>

        <div class="share-section">
          <p class="share-title">Share this article</p>
          <div class="share-buttons">
            <v-btn icon variant="text" color="#1DA1F2" @click="shareTwitter">
              <v-icon>mdi-twitter</v-icon>
            </v-btn>
            <v-btn icon variant="text" color="#0077B5" @click="shareLinkedIn">
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
            <v-btn icon variant="text" color="#25D366" @click="shareWhatsApp">
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
            <v-btn icon variant="text" color="#666" @click="copyLink">
              <v-icon>mdi-link</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="footer-content">
          <p class="footer-description">
            Software developer and Technical communicator working in corporate
            Sweden. I share authentic, real-world advice about succeeding in
            tech based on my journey from software engineering to technical
            communication.
          </p>
          <p class="footer-text">Thanks for reading! 💙</p>
          <v-btn to="/blog" variant="outlined" color="cyan" class="mt-4">
            ← Back to All Posts
          </v-btn>
        </div>
      </footer>
    </article>
  </v-container>
</template>

<script>
import { postMap } from "@/content/index.js";

export default {
  data() {
    return { currentPost: null };
  },
  created() {
    this.loadPost();
  },
  watch: {
    "$route.params.id": function () {
      this.loadPost();
    },
  },
  methods: {
    loadPost() {
      const postId = this.$route.params.id;
      if (postMap[postId]) {
        this.currentPost = postMap[postId];
      } else {
        console.error("Post not found");
        this.$router.push("/blog");
      }
    },
    sendEmail() {
      const emailAddress = "hello.aishainsweden@gmail.com";
      const subject = "Inquiry from your personal website";
      // Use window.location.href to force browser navigation
      window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(
        subject
      )}`;
    },
    shareTwitter() {
      const url = window.location.href;
      const text = this.currentPost.title;
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          text
        )}&url=${encodeURIComponent(url)}`,
        "_blank"
      );
    },
    shareLinkedIn() {
      const url = window.location.href;
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          url
        )}`,
        "_blank"
      );
    },
    shareWhatsApp() {
      const url = window.location.href;
      const text = this.currentPost.title;
      window.open(
        `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
        "_blank"
      );
    },
    copyLink() {
      navigator.clipboard.writeText(window.location.href);
      alert("Link copied to clipboard!");
    },
    handleBlogContentClick(event) {
      const gatedLink = event.target.closest("a[data-gated='true']");
      if (!gatedLink) return;

      const isSubscribed =
        window.localStorage.getItem("newsletterSubscribed") === "true";

      if (isSubscribed) return;

      event.preventDefault();
      const targetUrl = gatedLink.getAttribute("href");

      this.$router.push({
        name: "Newsletter",
        query: {
          source: "free-ai-resources",
          redirect: this.$route.fullPath,
          target: targetUrl,
        },
      });
    },
  },
};
</script>

<style scoped>
.blog-detail {
  max-width: 850px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  min-height: 100vh;
  background: linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%);
}

.blog-nav {
  margin-bottom: 3rem;
  animation: fadeInDown 0.6s ease;
}

.back-btn {
  color: #00bcd4;
  font-weight: 600;
  text-transform: none;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background-color: rgba(0, 188, 212, 0.1);
  transform: translateX(-5px);
}

.blog-header {
  margin-bottom: 4rem;
  padding-bottom: 2.5rem;
  border-bottom: 3px solid #e8eaf6;
  animation: fadeIn 0.8s ease;
}

.blog-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  letter-spacing: -1px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.blog-meta {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 1.5rem;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
}

.publish-date {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #f1f5f9;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.publish-date:hover {
  background: #e2e8f0;
  transform: translateY(-2px);
}

.blog-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  line-height: 2;
  font-size: 17px;
  color: #334155;
  letter-spacing: 0.3px;
  margin-bottom: 4rem;
  animation: fadeInUp 1s ease;
}

.blog-content h2 {
  margin-top: 4rem;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  border-left: 6px solid #00bcd4;
  padding-left: 1.5rem;
  position: relative;
  transition: all 0.3s ease;
}

.blog-content h2:hover {
  border-left-color: #0097a7;
  transform: translateX(5px);
}

.blog-content h2::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 0;
  bottom: 0;
  width: 6px;
  background: linear-gradient(180deg, #00bcd4 0%, #0097a7 100%);
  border-radius: 3px;
}

.blog-content h3 {
  content: counter(section) ".";
  counter-increment: section;
  margin-top: 2.5rem;
  margin-bottom: 1.25rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.blog-content h3::before {
  content: "▸";
  color: #00bcd4;
  font-size: 1.2rem;
  font-weight: bold;
}

.blog-content p {
  margin-bottom: 1.75rem;
  text-align: left;
  line-height: 2;
  color: #475569;
}

.blog-content strong {
  font-weight: 700;
  color: #0f172a;
  background: linear-gradient(120deg, #fef08a 0%, #fef08a 100%);
  background-repeat: no-repeat;
  background-size: 100% 40%;
  background-position: 0 85%;
  padding: 0 0.2rem;
}

.blog-content em {
  font-style: italic;
  color: #64748b;
}

.blog-content ul,
.blog-content ol {
  margin: 2rem 0;
  padding-left: 2rem;
}

.blog-content li {
  margin-bottom: 1rem;
  line-height: 2;
  color: #475569;
  position: relative;
  padding-left: 0.5rem;
}

.blog-content li::marker {
  color: #00bcd4;
  font-weight: bold;
}

.blog-content blockquote {
  margin: 3rem 0;
  padding: 1.5rem 2rem;
  border-left: 5px solid #00bcd4;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  font-style: italic;
  color: #0c4a6e;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 188, 212, 0.1);
  position: relative;
}

.blog-content blockquote::before {
  content: '"';
  font-size: 4rem;
  color: rgba(0, 188, 212, 0.2);
  position: absolute;
  top: -10px;
  left: 10px;
  font-family: Georgia, serif;
}

.blog-content a {
  color: #00bcd4;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
}

.blog-content a:hover {
  color: #0097a7;
  border-bottom-color: #0097a7;
}

.blog-footer {
  margin-top: 5rem;
  padding-top: 3rem;
  animation: fadeIn 1.2s ease;
}

.footer-divider {
  background: linear-gradient(
    90deg,
    transparent 0%,
    #cbd5e1 50%,
    transparent 100%
  );
  margin-bottom: 2rem;
  height: 2px;
}

.footer-content {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.footer-text {
  font-size: 1.1rem;
  color: #475569;
  font-weight: 500;
  margin-bottom: 1rem;
}

.footer-description {
  font-size: 0.9rem;
  color: #64748b;
  max-width: 560px;
  margin: 0 auto 1.2rem;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.blog-title {
  font-size: 1.75rem;
  letter-spacing: -0.5px;
}

.blog-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  line-height: 2;
  font-size: 17px;
  color: #334155;
  letter-spacing: 0.3px;
  margin-bottom: 4rem;
  animation: fadeInUp 1s ease;
  counter-reset: section;
  text-align: justify;
  text-justify: inter-word;
}

.blog-content h2,
.blog-content h3 {
  text-align: left;
}

.blog-content h3 {
  margin-top: 2.5rem;
  margin-bottom: 1.25rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.blog-content h3::before {
  content: counter(section) ".";
  counter-increment: section;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 800;
  min-width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00bcd4 0%, #0097a7 100%);
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 188, 212, 0.3);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.blog-content h3:hover::before {
  transform: scale(1.15);
  box-shadow: 0 6px 12px rgba(0, 188, 212, 0.4);
}
.blog-title {
  font-size: 1.75rem;
  letter-spacing: -0.5px;
}

.blog-content {
  font-size: 16px;
  text-align: left;
}

.blog-content h2 {
  font-size: 1.5rem;
  margin-top: 3rem;
}

.blog-content h3 {
  font-size: 1.2rem;
}

.blog-content h3::before {
  min-width: 2rem;
  height: 2rem;
  font-size: 0.95rem;
}

.share-section {
  text-align: center;
  margin: 3rem 0;
}

.share-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 1rem;
}

.share-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.share-buttons .v-btn {
  transition: all 0.3s ease;
}

.share-buttons .v-btn:hover {
  transform: translateY(-3px);
}

.read-time {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #f1f5f9;
  border-radius: 20px;
}

h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
}

.author-bio {
  display: flex;
  align-items: center;
  gap: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 2.5rem;
  border-radius: 16px;
  margin: 4rem 0 3rem 0;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.author-bio:hover {
  box-shadow: 0 8px 20px rgba(0, 188, 212, 0.15);
  transform: translateY(-2px);
}

.author-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #00bcd4;
  box-shadow: 0 4px 12px rgba(0, 188, 212, 0.3);
  flex-shrink: 0;
}

.author-info h4 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.75rem;
}

.author-info p {
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 1.25rem;
  font-size: 0.95rem;
}

.author-social {
  display: flex;
  gap: 0.75rem;
}

.author-social .v-btn {
  transition: all 0.3s ease;
}

.author-social .v-btn:hover {
  transform: translateY(-3px);
}

@media (max-width: 768px) {
  .author-bio {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1.5rem;
  }

  .author-avatar {
    width: 100px;
    height: 100px;
  }

  .author-social {
    justify-content: center;
  }
}
</style>
